export const initialEditingRowData = {
  popup_notifications: true,
  email_notifications: true,
};

export const systemUsersOptions = [
  // 'administrative', 'staff',
  { label: 'Guardian', value: 'guardian' },
  { label: 'Student', value: 'student' },
  { label: 'Teacher', value: 'teacher' },
];

export const yearsLevels = [
  { label: '0', value: 0 },
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
];

export const genderOptions = [
  {
    label: 'Female',
    value: 'F',
  },
  {
    label: 'Male',
    value: 'M',
  },
];

export const statusOptions = [{ key: 'Active' }, { key: 'Inactive' }];

let AddViewDelete = (val) => ({
  view: val,
  add_edit: val,
  delete: val,
});

export const getLeadsOptions = (val) => {
  return {
    leads: {
      select_all: val,
      view: val,
      add_edit: val,
      delete: val,
    },
  };
};

export const systemPermissions = (val) => ({
  select_all: val,
  users_manager: AddViewDelete(val),
  contact_type: AddViewDelete(val),
  product_type: AddViewDelete(val),
  lead_statuses: AddViewDelete(val),
  quote_statuses: AddViewDelete(val),
  form_manager: AddViewDelete(val),
});

export const systemUserPermissions = (userType, val) => {
  if (['super_admin', 'system_admin'].includes(userType)) {
    return systemPermissions(val);
  }
  return false;
};

export const hideKeys = [
  'nationality',
  'id_number',
  'dob',
  'contact_no',
  'site_id',
  'kinship_attributes_name',
  'kinship_attributes_surname',
  'kinship_attributes_contact',
  'home_address',
  'postal_address',
];

export let user_roles = [
  // { label: 'Administrative', value: 'administrative' },
  { label: 'Admin', value: 'admin' },
  // { label: 'Assessor', value: 'assessor' },
  // { label: 'Guardian', value: 'guardian' },
  // { label: 'Student', value: 'student' },
  // { label: 'Staff', value: 'staff' },
  // { label: 'Teacher', value: 'teacher' },
];
